module.exports = __webpack_public_path__ + "static/img/class_29.f1bfea59.jpg";